<template>
  <div class="relative">
    <div :class="{ [backgroundColor]: !disabled }" class="relative">
      <svg
        v-if="!disabled"
        class="absolute -bottom-px w-full h-96"
        :fill="belowTiltColor"
        :viewBox="`0 0 ${isOnMobile ? 11 : 20} 100`"
        preserveAspectRatio="none"
      >
        <polygon points="0,100 100,0 100,100" />
      </svg>

      <slot />
    </div>
  </div>
</template>

<script>
import { isOnMobile } from "@/utils/media"

export default {
  name: "TiltedBackground",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: "bg-background-yellow"
    },
    belowTiltColor: {
      type: String,
      default: "white"
    }
  },
  computed: {
    isOnMobile() {
      return isOnMobile()
    }
  }
}
</script>
